import { storeTTData } from '@/redux/actions/trade-trust';
import api from '@/services/api/etr.js';
import { immerable } from 'immer';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import useRecordDetail from '../use-record-detail/index';

class EtrDocument {

	[immerable] = true

	constructor(params) {
		this.transferableRecordId = params.transferableRecordId
		this.name = params.name
		this.issuer = params.issuer
		this.type = params.type
		this.status = params.status
		this.created = params.created
		this.ttData = params.ttData
		this.eventStatus = params.eventStatus
	}

}

const useEtrDocument = () => {

	const dispatch = useDispatch()
	const { RecordDetail, serialize: serializeRecordDetail } = useRecordDetail();

	const [etrDocListLoading, setEtrDocListLoading] = useState(false)
	const [etrDocErrorMsg, setEtrDocErrorMsg] = useState()
	const [etrDocDetails, setEtrDocDetails] = useState()
	const [etrDocBlockchainDetails, setEtrDocBlockchainDetails] = useState();
	const [etrDocBlockchainDetailsLoading, setEtrDocBlockchainDetailsLoading] = useState(false);
	const [etrDocEndorsechainDetails, setEtrDocEndorsechainDetails] = useState();
	const [etrDocEndorsechainDetailsLoading, setEtrDocEndorsechainDetailsLoading] = useState(false);
	const [etrDocList, setEtrDocList] = useState([])
	const [metaData, setMetaData] = useState(null)
	const [activityLog, setActivityLog] = useState([]);

	async function fetchEtrDocumentList(params) {
		setEtrDocListLoading(true)

		const [error, response] = await api.paginateTransferableDocumentList(params)

		if (error) {
			setEtrDocErrorMsg(error);
			setEtrDocListLoading(false);
			return;
		}

		setEtrDocListLoading(false);
		const { items, meta } = response ?? {};
		const serializedData = items?.map(entry => serialize(entry));
		const newItems = serializedData?.map(dataParams => new EtrDocument(dataParams));
		setMetaData(meta);
		setEtrDocList(newItems);
	}

	async function fetchEtrDocumentDetails(params) {
		setEtrDocListLoading(true)

		const [error, response] = await api.getRecordTransferableDetails(params)

		if (error) {
			setEtrDocErrorMsg(error);
			setEtrDocListLoading(false);
			return;
		}

		if (response?.ttData) {
			const newItems = new RecordDetail(serializeRecordDetail(response?.ttData))
			dispatch(storeTTData(newItems));
		}
		setEtrDocListLoading(false);
		setEtrDocDetails(response);
	}

	async function fetchEtrDocumentBlockchainDetails(params) {
		setEtrDocBlockchainDetailsLoading(true);

		const [error, response] =
			await api.getTransferableRecordBlockchainDetails(params);

		if (error) {
			if (error?.message?.includes("timeout")) {
				setEtrDocErrorMsg('timeout');
			} else {
				setEtrDocErrorMsg(error);
			}
			setEtrDocBlockchainDetailsLoading(false);
			return;
		}

		setEtrDocBlockchainDetailsLoading(false);
		setEtrDocBlockchainDetails(response);
	}

	async function fetchEtrDocumentEndorsechainDetails(params) {
		setEtrDocEndorsechainDetailsLoading(true);
		const [error, response] = await api.getTransferableRecordEndorsechainDetails(params);
		if (error) {
			if (error?.message?.includes("timeout")) {
				setEtrDocErrorMsg('timeout');
			}
			setEtrDocEndorsechainDetailsLoading(false);
			return;
		}

		setEtrDocEndorsechainDetailsLoading(false);
		setEtrDocEndorsechainDetails(response);
	}

	async function getActivityLog(id) {
		const [error, response] = await api.activityLog(id);

		if (error) {
			setActivityLog([]);
			return setEtrDocErrorMsg("Transaction API has error");
		}

		setActivityLog(response);
	}

	function serialize(entry) {
		return {
			transferableRecordId: entry.transferableRecordId,
			name: entry.name,
			issuer: entry.issuer,
			type: entry.type,
			status: entry.status,
			created: entry.created,
			ttData: entry.ttData,
			eventStatus: entry.eventStatus,
		}
	}

	return {
		fetchEtrDocumentList,
		fetchEtrDocumentDetails,
		fetchEtrDocumentBlockchainDetails,
		fetchEtrDocumentEndorsechainDetails,
		etrDocList,
		etrDocListLoading,
		etrDocErrorMsg,
		meta: metaData,
		etrDocDetails,
		etrDocBlockchainDetails,
		etrDocEndorsechainDetails,
		etrDocBlockchainDetailsLoading,
		etrDocEndorsechainDetailsLoading,
		getActivityLog,
		activityLog
	}

}

export default useEtrDocument
